import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import PiercingPage from "@/pages/PiercingPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PiercingPage />} />
          <Route path="/piercing" element={<PiercingPage />} />
          <Route path="/piercing/admin" element={<AdminPage />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
